/**
 * Debajo de este porcentaje la batería se dice **en color**, no con otro dibujo: severidad = color
 * (ADR-0021 del lado de la capa). El umbral es el del espécimen (`modal-frame.tsx:67`) y coincide
 * con el segundo escalón de `BATTERY_ICON_FROM_LEVEL`, donde el icono ya venía marcando el cambio
 * con la cantidad de barras.
 */
export const BATTERY_LOW_THRESHOLD = 20;
